import React from 'react';
import './style.scss';

const BillingTableErrorRow = () => (
    <div className="BillingTableErrorRow">
        !
    </div>
);

export default BillingTableErrorRow;
